export default {
  name: "TwoPlayerPKGame",
  data() {
    return {
      answerCountNumberInterval: null,
      answerCountNumber: 0,
      countdownNumber: 3,
      countdownInterval: null,
      countdownAnimating: false,

      gameState: "setup",
      optionsPanelVisible: true,
      showConfirmDialog: false,

      // 选项缩放相关
      player1OptionsScale: 1,
      player2OptionsScale: 1,
      resizeObserver: null,
      // 1: 字母游戏 2: 单词游戏
      questionTypes: [
        {
          label: "看中选英",
          value: "chineseToEnglish",
          type: "1",
          disabled: false,
        },
        {
          label: "看英选中",
          value: "englishToChinese",
          type: "1",
          disabled: false,
        },
        { label: "中英混合", value: "mixed", type: "1", disabled: false },
        // { label: "字母归位", value: "letter", type: "1", disabled: false },
        { label: "纠错抢答", value: "wordSpell", type: "2", disabled: false },
        // { label: "单词纠错", value: "wordCorrect", type: "2", disabled: false },
        { label: "单词消消乐", value: "wordPair", type: "3", disabled: false },
        { label: "单词水果忍者", value: "wordNinja", type: "1", disabled: false },
      ],
      // 1:时间游戏 2: 抢答游戏
      gameModes: [
        { label: "限时赛", value: "timeLimit", type: "1", disabled: false },
        { label: "计时赛", value: "timeTrack", type: "1", disabled: false },
        { label: "计分赛", value: "scoreOnly", type: "1", disabled: false },
        { label: "抢答赛", value: "raceOnly", type: "2", disabled: false },
      ],
      selectedQuestionType: "wordSpell",
      selectedGameMode: "raceOnly",
      isRaceMode: false,
      timeLimit: 180, // 固定为60秒
      questionCount: 20, // 默认为20题，会根据实际词语数量动态调整
      timeMintute: 3, // 固定为3分钟
      questions: [],

      // Player 1 data
      player1Sum: 0,
      player1Score: 0,
      player1CurrentQuestion: 0,
      player1AnsweredCurrent: false,
      player1SelectedOption: null,
      player1Time: 0,
      player1Completed: false,

      // Player 2 data
      player2Sum: 0,
      player2Score: 0,
      player2CurrentQuestion: 0,
      player2AnsweredCurrent: false,
      player2SelectedOption: null,
      player2Time: 0,
      player2Completed: false,

      // Timers
      gameTimer: null,
      remainingTime: 0,
      elapsedTime: 0,

      // Game result
      winner: null,
      mapType: new Map(),

      vocabulary: [
        { chinese: "苹果", english: "apple" },
        { chinese: "香蕉", english: "banana mother" },
        { chinese: "橙子", english: "orange " },
        { chinese: "电脑", english: "computer mother" },
        { chinese: "手机", english: "mobile phone " },
        { chinese: "学校", english: "school mother" },
        { chinese: "老师", english: "teacher " },
        { chinese: "学生", english: "student mother" },
        { chinese: "书本", english: "book " },
        { chinese: "笔记本", english: "notebook mother" },
        { chinese: "汽车", english: "car " },
        { chinese: "自行车", english: "bicycle mother" },
        { chinese: "飞机", english: "airplane " },
        { chinese: "火车", english: "train mother" },
        { chinese: "医院", english: "hospital " },
        { chinese: "医生", english: "doctor " },
        { chinese: "护士", english: "nurse mother" },
        { chinese: "餐厅", english: "restaurant " },
        { chinese: "食物", english: "food mother" },
        { chinese: "水", english: "water " },
        { chinese: "咖啡", english: "coffee mother" },
        { chinese: "茶", english: "tea " },
        { chinese: "朋友", english: "friend mother" },
        { chinese: "家庭", english: "family " },
        { chinese: "父亲", english: "father mother" },
        { chinese: "母亲", english: "mother " },
        { chinese: "兄弟", english: "brother mother" },
        { chinese: "姐妹", english: "sister " },
        { chinese: "工作", english: "work mother" },
        { chinese: "时间", english: "time " },
      ],
    };
  },
  watch: {
    timeMintute: {
      handler(val) {
        this.timeLimit = val * 60;
      },
      deep: true,
      immediate: true,
    },
    selectedQuestionType: {
      handler(val) {
        if (val === "wordSpell") {
          this.gameModes.forEach((item) => {
            if (item.value === "timeLimit") {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
          });
          this.selectedGameMode = "timeLimit";
          this.mapType.set("type", "timeLimit");
        } else if (val === "wordCorrect") {
          this.gameModes.forEach((item) => {
            if (item.type === "1") {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
          });
          this.selectedGameMode = "raceOnly";
          this.mapType.set("type", "raceOnly");
        } else {
          this.gameModes.forEach((item) => {
            if (item.type === "2") {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
          });
          if (this.selectedGameMode === "raceOnly") {
            this.selectedGameMode = "timeLimit";
            this.mapType.set("type", "timeLimit");
          }
        }
        console.log("selectedGameMode", val, this.questionTypes);
      },
      immediate: true,
      deep: true,
    },
    selectedGameMode: {
      handler(val) {
        if (val !== "timeLimit") {
          this.timeLimit = 180;
          this.timeMintute = 3;
        }
        if (this.gameState === "results") {
          this.resetGame();
          this.resetPlayerData();
        }
        this.isRaceMode = val === "raceOnly" ? true : false;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    backToSetup() {
      // 根据当前环境判断使用哪种返回上一页的方法
      if (typeof wx !== "undefined") {
        // 如果在小程序环境中，使用小程序的返回方法
        // eslint-disable-next-line no-undef
        if (
          typeof wx !== "undefined" &&
          // eslint-disable-next-line no-undef
          typeof wx.navigateBack === "function"
        ) {
          // eslint-disable-next-line no-undef
          wx.navigateBack({
            delta: 1,
          });
        }
      } else if (this.$router) {
        // 如果在Vue Router环境中，使用router的back方法
        this.$router.back();
      } else if (window.history && window.history.length > 1) {
        // 如果不在Vue Router环境中，使用浏览器的历史记录返回
        window.history.back();
      } else {
        // 如果没有历史记录，则重定向到指定的页面
        window.location.href = "/";
      }
    },
    //调整时间
    triggerTime(flag) {
      // 确保时间在 1 到 20 分钟的范围内
      if (flag) {
        if (this.timeMintute < 20) {
          this.timeMintute++;
        }
      } else {
        if (this.timeMintute > 1) {
          this.timeMintute--;
        }
      }
    },
    getRandomSizeClass(index, questionIndex) {
      const seed = (index + 1) * (questionIndex + 1);
      return (seed % 3) + 1;
    },

    toggleOptionsPanel() {
      this.optionsPanelVisible = !this.optionsPanelVisible;
    },
    downStartGame() {
      if (typeof this.onStartGameClick === "function") {
        this.onStartGameClick();
      }
      const prevCountdown = this.countdownNumber;
      this.gameState = "countdown";
      this.countdownNumber = 3;
      this.resetPlayerData();
      if (prevCountdown === 3 && typeof this.announceCountdownStart === "function") {
        this.announceCountdownStart();
      }
      this.countdownInterval = setInterval(() => {
        if (this.countdownNumber > 0) {
          this.countdownNumber--;
        } else {
          clearInterval(this.countdownInterval);
          if (this.selectedQuestionType === "letter") {
            this.letterStartGame();
          } else if (this.selectedQuestionType === "wordSpell" || this.selectedQuestionType === "wordCorrect") {
            this.raceStartGame();
          } else if (this.selectedQuestionType === "wordPair") {
            this.initHappyGame();
            if (this.selectedGameMode === "timeLimit") {
              this.remainingTime = this.timeLimit;
              this.startTimeLimitTimer();
            }
          } else if (this.selectedQuestionType === "wordNinja") {
            this.initNinjaGame();
            // 计时赛：始终正计时（顶部显示累计用时），结束由玩法驱动（完成/生命耗尽/水果消失）
            this.elapsedTime = 0;
            this.startTimeTrackTimer();
          } else {
            this.startGame();
          }
        }
      }, 1000);
    },
    startGame() {
      this.generateQuestions();
      this.gameState = "playing";

      this.optionsPanelVisible = false;

      // 初始化缩放监听并计算初始缩放
      this.$nextTick(() => {
        this.initScaleObserver();
        this.calculateOptionsScale();
      });

      if (this.selectedGameMode === "timeLimit" || this.selectedGameMode === "scoreOnly") {
        this.remainingTime = this.timeLimit;
        this.startTimeLimitTimer();
      } else if (this.selectedGameMode === "timeTrack") {
        this.elapsedTime = 0;
        this.startTimeTrackTimer();
      }
    },
    runCountdownAnimation() {
      // 触发动画
      this.countdownAnimating = true;

      // 设置倒计时定时器
      this.countdownTimer = setTimeout(() => {
        // 重置动画状态
        this.countdownAnimating = false;

        // 延迟一小段时间后减少倒计时数字，让动画有时间完成
        setTimeout(() => {
          this.countdownNumber--;

          if (this.countdownNumber >= 0) {
            // 继续倒计时
            this.runCountdownAnimation();
          } else {
            // 倒计时结束，开始游戏
            this.startGame();
          }
        }, 100);
      }, 900); // 动画持续时间
    },
    resetGameConfirm() {
      this.showConfirmDialog = true;
    },

    cancelReset() {
      this.showConfirmDialog = false;
    },

    confirmReset() {
      this.showConfirmDialog = false;
      this.resetGame();
    },

    resetGame() {
      if (this.gameTimer) {
        clearInterval(this.gameTimer);
        this.gameTimer = null;
      }
      this.player2Score = 0;
      this.player1Score = 0;
      this.remainingTime = 0;
      this.elapsedTime = 0;
      this.gameState = "setup";
      this.optionsPanelVisible = true;
      this.winner = null;
      this.player1Completed = false;
      this.player2Completed = false;
      this.player1Sum = 0;
      this.player2Sum = 0;
      this.player1CurrentQuestion = 0;
      this.player2CurrentQuestion = 0;
      this.questions = []; // Reset questions
      this.letterResetPlayerData();
      if (typeof this.ninjaCleanup === "function") {
        this.ninjaCleanup(); // 清理水果忍者循环与数据
      }
      this.clearAllTimers(); // 清除所有定时器
      this.resetAnimationState(); // 重置动画状态
      // 重置缩放比例
      this.player1OptionsScale = 1;
      this.player2OptionsScale = 1;
      this.destroyScaleObserver();
    },

    resetPlayerData() {
      this.remainingTime = 0;
      this.elapsedTime = 0;
      this.player1Score = 0;
      this.player1CurrentQuestion = 0;
      this.player1AnsweredCurrent = false;
      this.player1SelectedOption = null;
      this.player1Time = 0;
      this.player1Completed = false;
      this.player2Score = 0;
      this.player2CurrentQuestion = 0;
      this.player2AnsweredCurrent = false;
      this.player2SelectedOption = null;
      this.player2Time = 0;
      this.player2Completed = false;
      this.letterResetPlayerData();
      this.raceResetPlayerData();
    },

    generateQuestions() {
      const shuffledVocabulary = [...this.vocabulary].sort(() => 0.5 - Math.random());
      // 使用实际词汇量，如果词汇量小于questionCount则使用全部词汇
      const actualCount = Math.min(this.questionCount, this.vocabulary.length);
      const selectedVocabulary = shuffledVocabulary.slice(0, actualCount);

      this.questions = selectedVocabulary.map((item) => {
        // Generate 3 wrong options
        const wrongOptions = this.getWrongOptions(item);

        if (this.selectedQuestionType === "chineseToEnglish") {
          const options = [...wrongOptions.map((opt) => opt.english), item.english].sort(() => 0.5 - Math.random());
          return {
            question: item.chinese,
            options: options,
            correctIndex: options.indexOf(item.english),
          };
        } else if (this.selectedQuestionType === "englishToChinese") {
          const options = [...wrongOptions.map((opt) => opt.chinese), item.chinese].sort(() => 0.5 - Math.random());
          return {
            question: item.english,
            options: options,
            correctIndex: options.indexOf(item.chinese),
          };
        } else {
          if (Math.random() > 0.5) {
            const options = [...wrongOptions.map((opt) => opt.english), item.english].sort(() => 0.5 - Math.random());
            return {
              question: item.chinese,
              options: options,
              correctIndex: options.indexOf(item.english),
            };
          } else {
            const options = [...wrongOptions.map((opt) => opt.chinese), item.chinese].sort(() => 0.5 - Math.random());
            return {
              question: item.english,
              options: options,
              correctIndex: options.indexOf(item.chinese),
            };
          }
        }
      });
    },

    getWrongOptions(correctItem) {
      return this.vocabulary
        .filter((item) => item !== correctItem)
        .sort(() => 0.5 - Math.random())
        .slice(0, 3);
    },

    startTimeLimitTimer() {
      this.gameTimer = setInterval(() => {
        this.remainingTime--;
        if (this.remainingTime <= 0) {
          this.endGame();
        }
      }, 1000);
    },

    startTimeTrackTimer() {
      this.gameTimer = setInterval(() => {
        this.elapsedTime++;
        this.player1Time++;
        this.player2Time++;
      }, 1000);
    },

    // 触摸事件处理 - 支持多点触控
    handleTouchSelect(player, optionIndex, event) {
      // 阻止默认行为和事件冒泡，确保双方独立
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.selectOption(player, optionIndex);
    },
    // 计算选项缩放比例
    calculateOptionsScale() {
      this.$nextTick(() => {
        // 检查当前选项是否为中文
        const isChineseOptions = this.isCurrentOptionsContainChinese();

        // 如果是英文选项，不需要缩放
        if (!isChineseOptions) {
          this.player1OptionsScale = 1;
          this.player2OptionsScale = 1;
          return;
        }

        // 玩家1选项区域
        const player1Container = this.$el?.querySelector(".player1-options");
        if (player1Container) {
          this.player1OptionsScale = this.getScaleForContainer(player1Container);
        }
        // 玩家2选项区域
        const player2Container = this.$el?.querySelector(".player2-options");
        if (player2Container) {
          this.player2OptionsScale = this.getScaleForContainer(player2Container);
        }
      });
    },
    // 检查当前选项是否包含中文
    isCurrentOptionsContainChinese() {
      // 根据题目类型判断
      // chineseToEnglish: 看中选英，选项是英文
      // englishToChinese: 看英选中，选项是中文
      // mixed: 混合，需要检测实际内容
      if (this.selectedQuestionType === "chineseToEnglish") {
        return false; // 选项是英文，不缩放
      }
      if (this.selectedQuestionType === "englishToChinese") {
        return true; // 选项是中文，需要缩放
      }
      // mixed 模式，检测当前题目的选项内容
      const currentQuestion = this.questions[this.player1CurrentQuestion];
      if (currentQuestion && currentQuestion.options && currentQuestion.options.length > 0) {
        // 检测第一个选项是否包含中文
        const firstOption = currentQuestion.options[0];
        return this.containsChinese(firstOption);
      }
      return false;
    },
    // 检测字符串是否包含中文字符
    containsChinese(str) {
      if (!str) return false;
      // 中文字符的Unicode范围
      const chineseRegex = /[\u4e00-\u9fa5]/;
      return chineseRegex.test(str);
    },
    // 获取容器的缩放比例
    getScaleForContainer(container) {
      if (!container) return 1;

      const parentEl = container.parentElement;
      if (!parentEl) return 1;

      // 获取父容器可用高度（减去问题区域和边距）
      const questionEl = parentEl.querySelector(".question");
      const questionHeight = questionEl ? questionEl.offsetHeight + 32 : 120;
      const parentHeight = parentEl.offsetHeight;
      const availableHeight = parentHeight - questionHeight - 20; // 预留边距

      // 获取选项容器实际高度
      const contentHeight = container.scrollHeight;

      if (contentHeight <= 0 || availableHeight <= 0) return 1;

      // 如果内容超出可用高度，计算缩放比例
      if (contentHeight > availableHeight) {
        const scale = availableHeight / contentHeight;
        // 限制最小缩放比例为0.85，避免过小导致文字不清晰
        return Math.max(0.85, Math.min(1, scale));
      }
      return 1;
    },
    // 初始化缩放监听
    initScaleObserver() {
      // 使用 ResizeObserver 监听容器尺寸变化
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.gameState === "playing") {
            this.calculateOptionsScale();
          }
        });

        // 监听玩家区域
        const playerSections = this.$el?.querySelectorAll(".player-section");
        if (playerSections) {
          playerSections.forEach((section) => {
            this.resizeObserver.observe(section);
          });
        }
      }
    },
    // 清理缩放监听
    destroyScaleObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },
    selectOption(player, optionIndex) {
      if (this.gameState !== "playing") return;

      if (player === 0) {
        const currentQuestion = this.questions[this.player1CurrentQuestion];
        this.player1SelectedOption = optionIndex;
        this.player1AnsweredCurrent = true;

        if (optionIndex === currentQuestion.correctIndex) {
          // 答对了，加分并立即进入下一题
          this.player1Score++;
          this.player1Sum = this.player1Score * 10;
          this.playAnswerFeedback(true);
          this.advanceToNextQuestionForPlayer1(true);
        } else {
          // 答错了，显示红色后延迟进入下一题
          // 更改：添加延迟，让玩家看到错误答案的红色标记
          this.playAnswerFeedback(false);
          if (this.player1Sum > 0) {
            this.player1Sum = this.player1Sum - 5;
          }
          if (this.selectedGameMode === "timeTrack") {
            clearInterval(this.gameTimer);
            this.player1Time = this.player1Time + 2;
            this.startTimeTrackTimer();
          } else {
            setTimeout(() => {
              this.advanceToNextQuestionForPlayer1(false);
            }, 500); // 800毫秒延迟
          }
        }
      } else {
        // Player 2
        const currentQuestion = this.questions[this.player2CurrentQuestion];
        this.player2SelectedOption = optionIndex;
        this.player2AnsweredCurrent = true;

        if (optionIndex === currentQuestion.correctIndex) {
          // 答对了，加分并立即进入下一题
          this.player2Score++;
          this.player2Sum = this.player2Score * 10;
          this.playAnswerFeedback(true);
          this.advanceToNextQuestionForPlayer2();
        } else {
          // 答错了，显示红色后延迟进入下一题
          // 更改：添加延迟，让玩家看到错误答案的红色标记
          this.playAnswerFeedback(false);
          if (this.player2Sum > 0) {
            this.player2Sum = this.player2Sum - 5;
          }
          if (this.selectedGameMode === "timeTrack") {
            clearInterval(this.gameTimer);
            this.player2Time = this.player2Time + 2;
            this.startTimeTrackTimer();
          } else {
            setTimeout(() => {
              this.advanceToNextQuestionForPlayer2();
            }, 500); // 800毫秒延迟
          }
        }
      }
    },
    // 更改：新增方法，将玩家1进入下一题的逻辑抽取出来
    advanceToNextQuestionForPlayer1() {
      this.player1CurrentQuestion++;
      this.player1AnsweredCurrent = false;
      this.player1SelectedOption = null;

      if (this.player1CurrentQuestion >= this.questions.length) {
        this.player1Completed = true;
        if (!this.selectedGameMode === "timeTrack") {
          this.player1Time = this.elapsedTime;
        }
        // 确保当前问题索引不超过题目总数
        this.player1CurrentQuestion = this.questions.length;

        if (this.player1Completed && this.player2Completed) {
          this.endGame();
        }
      }
    },

    // 更改：新增方法，将玩家2进入下一题的逻辑抽取出来
    advanceToNextQuestionForPlayer2() {
      this.player2CurrentQuestion++;
      this.player2AnsweredCurrent = false;
      this.player2SelectedOption = null;

      if (this.player2CurrentQuestion >= this.questions.length) {
        this.player2Completed = true;
        if (!this.selectedGameMode === "timeTrack") {
          this.player2Time = this.elapsedTime;
        }
        // 确保当前问题索引不超过题目总数
        this.player2CurrentQuestion = this.questions.length;

        if (this.player1Completed && this.player2Completed) {
          this.endGame();
        }
      }
    },
    endGame() {
      // 水果忍者：记录本局成绩到内存排行榜，并停止 rAF 循环（保留数据供结果页展示）
      if (this.selectedQuestionType === "wordNinja") {
        if (typeof this.ninjaRecordRank === "function") {
          this.ninjaRecordRank();
        }
        if (typeof this.ninjaStopLoop === "function") {
          this.ninjaStopLoop();
        }
      }
      if (this.answerCountNumberInterval) {
        clearInterval(this.answerCountNumberInterval);
        this.answerCountNumberInterval = null;
      }
      if (this.gameTimer) {
        clearInterval(this.gameTimer);
        this.gameTimer = null;
      }

      if (this.selectedGameMode === "timeTrack" && this.player1Completed && this.player2Completed) {
        if (this.player1Time < this.player2Time) {
          this.winner = "player1";
        } else if (this.player2Time < this.player1Time) {
          this.winner = "player2";
        } else {
          this.winner = "tie";
        }
      } else if (this.selectedGameMode === "scoreOnly") {
        if (this.player1Sum > this.player2Sum) {
          this.winner = "player1";
        } else if (this.player2Sum > this.player1Sum) {
          this.winner = "player2";
        } else {
          this.winner = "tie";
        }
      } else {
        if (this.player1Score > this.player2Score) {
          this.winner = "player1";
        } else if (this.player2Score > this.player1Score) {
          this.winner = "player2";
        } else {
          this.winner = "tie";
        }
      }

      this.gameState = "results";
    },

    formatTime(seconds, state = false) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      if (state) {
        return `${minutes}分${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}秒`;
      } else {
        return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
      }
    },
    triggerQuestionCount(isAdd) {
      if (isAdd) {
        if (this.questionCount + 5 <= this.vocabulary.length) {
          this.questionCount += 5;
        } else {
          this.questionCount = this.vocabulary.length;
        }
      } else {
        if (this.questionCount - 5 >= 5) {
          this.questionCount -= 5;
        } else {
          this.questionCount = 5;
        }
      }
    },
    validateQuestionCount() {
      // Ensure integer
      this.questionCount = Math.floor(this.questionCount);

      if (this.questionCount < 5) {
        this.questionCount = 5;
      } else if (this.questionCount > this.vocabulary.length) {
        this.questionCount = this.vocabulary.length;
      }
    },
  },
  beforeDestroy() {
    if (this.gameTimer) {
      clearInterval(this.gameTimer);
    }
    this.destroyScaleObserver();
  },
};
